import axios from "axios";
import { urls } from "../../utils/AppManager";
import { getAuthHeaders } from "../../utils/headers";

export const getDashboardAcquisitionTilesCount = async (fromDate, toDate) => {
  console.log(fromDate, toDate, " from api");
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.dashboardAcquisitionTilesCount}?&fromDate=${fromDate}&toDate=${toDate}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getGraphReportLeadSource = async (fromDate, toDate) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.graphReportLeadSource}?&fromDate=${fromDate}&toDate=${toDate}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getGraphReportLeadStage = async (fromDate, toDate) => {
  //console.log(fromDate, toDate, "35");
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.graphReportLeadStage}?&fromDate=${fromDate}&toDate=${toDate}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getGraphReportLeadPaymentInsight = async (fromDate, toDate) => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.graphReportLeadPaymentInsight}?&fromDate=${fromDate}&toDate=${toDate}`;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getGraphReportLeadConversionPerDay = async () => {
  const url =
    process.env.REACT_APP_API_BASE_URL + urls.graphReportLeadConversionPerDay;
  // console.log(url);
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRedisDashboardAcquisitionTilesCount = async (
  fromDate,
  toDate,
  timeline
) => {
  console.log("for redis api ", fromDate, " ", toDate )
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.redisdashboardAcquisitionTilesCount}?&fromDate=${fromDate}&toDate=${toDate}&timeline=${timeline}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRedisGraphReportLeadSource = async (
  fromDate,
  toDate,
  timeline
) => {
  console.log("for redis api ", fromDate, " ", toDate )
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.redisgraphReportLeadSource}?&fromDate=${fromDate}&toDate=${toDate}&timeline=${timeline}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRedisGraphReportLeadPaymentInsight = async (
  fromDate,
  toDate,
  timeline
) => {
  console.log("for redis api ", fromDate, " ", toDate )
  const url =
    process.env.REACT_APP_API_BASE_URL +
    `${urls.redisgraphReportLeadPaymentInsight}?&fromDate=${fromDate}&toDate=${toDate}&timeline=${timeline}`;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};

export const getRedisGraphReportLeadConversionPerDay = async () => {
  const url =
    process.env.REACT_APP_API_BASE_URL +
    urls.redisgraphReportLeadConversionPerDay;
  const headers = getAuthHeaders();
  const res = await axios
    .get(url, { headers })
    .then((response) => response.data)
    .catch((error) => {
      console.log(error, "error");
    });
  return res;
};
